import {Component, ViewChild} from '@angular/core';
import {AlertController, ModalController, NavController, NavParams, ViewController, Gesture } from 'ionic-angular';

@Component({
  selector: 'page-view-photo',
  templateUrl: 'view-photo.html',
})
export class ViewPhotoPage {

  @ViewChild('image') element;
  @ViewChild('imageParent') elementParent;

  image = null;
  container = null;
  transforms = [];
  adjustScale = 1;
  adjustDeltaX = 0;
  adjustDeltaY = 0;

  currentScale = null;
  currentDeltaX = null;
  currentDeltaY = null;

  public media: any;
  public src: string;
  public mediaType: string;
  private gesture: Gesture;
  public mediaLoaded:boolean = false;

  photo: {
    title: '',
    src: ''
  };
  photos = [];
  index = -1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController
  ) {
    this.photo = this.navParams.get('photo');
    if(this.navParams.get('photos')){
      this.photos = this.navParams.get('photos');
      this.index = this.navParams.get('index')
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ViewPhotoPage');
    this.image = this.element.nativeElement;
    this.container = this.elementParent.nativeElement;
    // Prevent long press saving on mobiles.
    this.container.addEventListener('touchstart', function(e) {
      e.preventDefault();
    });
    this.initGesture();
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

  removePhoto(){
    this.alertCtrl.create({
      title: 'Foto verwijderen',
      message: 'Wilt u deze foto verwijderen?',
      buttons: [
        {
          text: 'Nee',
          role: 'cancel'
        },{
          text: 'Ja',
          handler: () => {
            // @ts-ignore
            if(this.photos[this.index] && this.photos[this.index].file_id > 0){
              // @ts-ignore
              this.photos[this.index]._deleted = true;
              this.photos[this.index].src = '';
            } else {
              this.photos.splice(this.index, 1);
            }
            this.closeModal();
          }
        }
      ]
    }).present();
  }

  setMediaLoaded(){
    setTimeout(() => this.mediaLoaded = true, 200);
  }

  initGesture(){
    // create gesture obj w/ ref to DOM element
    this.gesture = new Gesture(this.element.nativeElement);

    // listen for the gesture
    this.gesture.listen();

    this.gesture.on('doubletap', (ev) => {
      this.transforms = [];
      this.adjustScale += 1;
      if (this.adjustScale >= 4) this.adjustScale = 1;
      this.transforms.push('scale(' + this.adjustScale + ')');
      this.container.style.transform = this.transforms.join(' ');
      this.container.style.setProperty('-webkit-transform', this.transforms.join(' '));
    });

    this.gesture.on('pinch', (ev) => {
      this.transforms = [];
      // Adjusting the current pinch/pan event properties using the previous ones set when they finished touching
      this.currentScale = this.adjustScale * ev.scale;
      this.currentDeltaX = this.adjustDeltaX + (ev.deltaX / this.currentScale);
      this.currentDeltaY = this.adjustDeltaY + (ev.deltaY / this.currentScale);
      // Concatinating and applying parameters.
      if (this.currentScale < 1) {
        this.currentScale = 1;
        this.currentDeltaX = 0;
        this.currentDeltaY = 0;
      }
      this.transforms.push('scale(' + this.currentScale + ')');
      this.transforms.push('translate(' + this.currentDeltaX + 'px,' + this.currentDeltaY + 'px)');
      this.container.style.transform = this.transforms.join(' ');
      this.container.style.setProperty('-webkit-transform', this.transforms.join(' '));
    });

    this.gesture.on('pinchend', (ev) => {
      // Saving the final transforms for adjustment next time the user interacts.
      this.adjustScale = this.currentScale;
      this.adjustDeltaX = this.currentDeltaX;
      this.adjustDeltaY = this.currentDeltaY;
    });

    this.gesture.on('panend', (ev) => {
      // Saving the final transforms for adjustment next time the user interacts.
      this.adjustScale = this.currentScale;
      this.adjustDeltaX = this.currentDeltaX;
      this.adjustDeltaY = this.currentDeltaY;
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/view-photo/view-photo.ts